import { isNumber } from 'lodash-es';

import { ORIENTATION } from '../../../chart-layout/types/constants.js';
import { useFormatter } from '../context/FormatterContext.js';
import { useOrientation } from '../context/RangeLegendOrientationContext.js';
import { useScale } from '../context/RangeLegendScaleContext.js';
import { InternalRangeItem } from '../types/range-legend.internal.js';

export const useBoundaryLabels = (
  items: InternalRangeItem[],
  rangeStartPosition: number,
  rangeEndPosition: number,
  min?: number,
  max?: number,
) => {
  const { scale } = useScale();
  const { formatter } = useFormatter();
  const { orientation } = useOrientation();

  const isReversed = orientation === ORIENTATION.Vertical;

  const firstItem = items.find(
    (item) => scale(isReversed ? item.to : item.from) === rangeStartPosition,
  );
  const lastItem = items.find(
    (item) => scale(isReversed ? item.from : item.to) === rangeEndPosition,
  );

  const firstItemValue = firstItem?.labels[isReversed ? 'to' : 'from'] ?? '';
  const lastItemValue = lastItem?.labels[isReversed ? 'from' : 'to'] ?? '';

  if (isReversed) {
    const formattedFirstValue = isNumber(max) ? formatter(max) : firstItemValue;

    const formattedLastValue = isNumber(min) ? formatter(min) : lastItemValue;

    return {
      firstLabel: formattedFirstValue,
      lastLabel: formattedLastValue,
    };
  }

  const formattedFirstValue = isNumber(min) ? formatter(min) : firstItemValue;

  const formattedLastValue = isNumber(max) ? formatter(max) : lastItemValue;

  return {
    firstLabel: formattedFirstValue,
    lastLabel: formattedLastValue,
  };
};
